module.exports = __webpack_public_path__ + "assets/img/clipboard.a754c187.svg";